import http from '../service/default'
import { useEffect } from 'react'

const ProtectedRoute = ({ children }) => {
  useEffect(() => {
    http.get(`${process.env.REACT_APP_CLIENTS_LOCATIONS}/v1/auth`)
  })

  return children
}

export default ProtectedRoute
